import { render } from "./PrincipalPage.vue?vue&type=template&id=10b9ccab"
import script from "./PrincipalPage.vue?vue&type=script&lang=js"
export * from "./PrincipalPage.vue?vue&type=script&lang=js"

import "./PrincipalPage.vue?vue&type=style&index=0&id=10b9ccab&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__